import React from 'react';
import { CheckIcon, ArrowLeftRightIcon } from 'lucide-react';
import { kitComparison, kitIncludes } from '../data/content';
export function KitComparison() {
  return <section aria-labelledby="kit-titulo" className="w-full bg-celeste-light py-14 sm:py-20" data-id="element-149" data-mp="gn9we1wdabv2">
      <div className="mx-auto max-w-5xl px-5" data-id="element-150" data-mp="phoj2pj88oo7">
        <h2 id="kit-titulo" className="text-center font-display text-2xl font-extrabold leading-tight text-navy text-balance sm:text-3xl" data-id="element-151" data-mp="pher4wemg7fv">
          🕊️ ¿Qué agrega el Kit Inclusión “Lectoescritura sin barreras”?
        </h2>

        <p className="mt-6 flex items-center justify-center gap-2 text-xs font-semibold text-navy/60 md:hidden" data-id="element-152" data-mp="1slq4lj579ee">
          <ArrowLeftRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-153" data-mp="6rox4bionpp0" />
          Deslizá para ver la tabla completa
        </p>

        <div className="mt-3 overflow-x-auto rounded-2xl border border-navy/10 bg-white shadow-card" data-id="element-154" data-mp="1d6zbnjqfbcr9">
          <table className="w-full min-w-[640px] border-collapse text-left" data-id="element-155" data-mp="1i50uq4nunc2q">
            <caption className="sr-only" data-id="element-156" data-mp="1ekhfrcdai1jx">
              Comparación de situaciones en el aula o en casa con y sin el Kit Inclusión
            </caption>
            <thead data-id="element-157" data-mp="19kl6axltphwz">
              <tr className="bg-navy text-white" data-id="element-158" data-mp="14mtiofs7ohyl">
                <th scope="col" className="px-4 py-3 font-display text-sm font-bold" data-id="element-159" data-mp="14li3ljtbfns6">
                  Situación en el aula o en casa
                </th>
                <th scope="col" className="px-4 py-3 font-display text-sm font-bold" data-id="element-160" data-mp="vn6c7fkmklyo">
                  ❌ Sin Kit
                </th>
                <th scope="col" className="px-4 py-3 font-display text-sm font-bold" data-id="element-161" data-mp="qudcx77xe5tz">
                  ✅ Con Kit
                </th>
              </tr>
            </thead>
            <tbody data-id="element-162" data-mp="gyjsl1nyt81n">
              {kitComparison.map((row, index) => <tr key={row.situation} className={index % 2 === 1 ? 'bg-cream' : 'bg-white'} data-id="element-163" data-mp="byfko014hln1" data-mpi={index}>
                  <th scope="row" className="border-t border-navy/10 px-4 py-3 text-sm font-bold text-navy" data-id="element-164" data-mp="7xlwr6nok6u5">
                    {row.situation}
                  </th>
                  <td className="border-t border-navy/10 px-4 py-3 text-sm text-coral" data-id="element-165" data-mp="28p2fg5frkxf">
                    {row.without}
                  </td>
                  <td className="border-t border-navy/10 px-4 py-3 text-sm font-semibold text-green-700" data-id="element-166" data-mp="3pezlxis1vudh">
                    {row.with}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="mt-8 rounded-2xl border border-navy/10 bg-white p-6 shadow-card" data-id="element-167" data-mp="l3njqnlb83zt">
          <h3 className="font-display text-lg font-extrabold text-navy" data-id="element-168" data-mp="79wcjlv1ww79">
            ✅ El Kit Inclusión incluye:
          </h3>
          <ul className="mt-4 grid gap-3 sm:grid-cols-2" data-id="element-169" data-mp="zytufnvcoqzh">
            {kitIncludes.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-170" data-mp="14pk0727ouvup">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-green-600" aria-hidden="true" data-id="element-171" data-mp="14qv1mvdnvrin" />
                <span className="text-sm leading-relaxed text-navy/80" data-id="element-172" data-mp="1a3a4g0m5fdvd">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}